import * as Cookie from 'js-cookie'
import * as React from 'react'
import * as DL from '../../../utils/datalayer'
import { CookiebarOptions } from '../../../widgets/cookiebar'
import cookiebar from '../../../widgets/cookiebar'

type CookieType = 'true' | 'false'

type CookiebarState = {
  accepted: CookieType | 'no'
}

const cookieName = 'consent'

const setCookieBarCookie = (value: CookieType): void => {
  Cookie.set(cookieName, value, { expires: 365, path: '/' })
}

const options = (
  onDone: (value: CookieType) => void,
  privacyLink: string
): CookiebarOptions => ({
  text: {
    title: I18n.t('cookie_bar.title'),
    main_text: I18n.t('cookie_bar.notice', { privacy_url: privacyLink })
  },
  acceptButton: {
    caption: I18n.t('cookie_bar.accept'),
    onAccept: () => {
      setCookieBarCookie('true')
      sendCookieToDataLayer('true')
      onDone('true')
    }
  },
  acceptOnlyFunctionalLink: {
    caption: I18n.t('cookie_bar.only_functional'),
    onAccept: () => {
      setCookieBarCookie('false')
      sendCookieToDataLayer('false')
      onDone('false')
    }
  }
})

const sendCookieToDataLayer = (value: CookieType): void =>
  DL.push({
    event: value == 'true' ? 'cookies_enabled' : 'cookies_disabled'
  })

const getValueFromCookie = (): CookieType | 'no' => {
  const value = Cookie.get(cookieName)

  if (!value) {
    return 'no'
  }

  if (value === 'true') {
    return 'true'
  }

  if (value === 'false') {
    return 'false'
  }
  return 'no'
}

type Props = {
  privacyUrl: string
}

export default class extends React.Component<Props, CookiebarState> {
  constructor(props: Props, context: any) {
    super(props, context)
    this.state = {
      accepted: 'no'
    }
  }

  componentWillMount() {
    this.setStateFromCookie()
  }

  setStateFromCookie() {
    this.setState({
      accepted: getValueFromCookie()
    })
  }

  render() {
    return this.state.accepted !== 'no'
      ? ''
      : cookiebar(
          options(_ => this.setStateFromCookie(), this.props.privacyUrl)
        )().run(() => null)
  }
}
